/** 星级量化接口版本，全项目统一在此维护 */
export const STAR_VERSION = '1.4'

export const STAR_VERSION_HEADERS = { starVersion: STAR_VERSION } as const

export function starHeaders(headers?: Record<string, any>) {
  return { ...(headers || {}), ...STAR_VERSION_HEADERS }
}
